import { message } from 'antd';
import warnGreen from '../assets/images/warn-green.png';
import warnYellow from '../assets/images/warn-yellow.png';
import messageErrorIcon from '../assets/images/message-error.png';
import messageSuccessIcon from '../assets/images/message-success.png';

let isMessageLocked = false;

export const setMessageLocked = (locked: boolean) => {
  isMessageLocked = locked;
};

message.config({
  duration: 3,
  maxCount: 1,
});
export const messageInfo = (msg: any) => {
  message.info({
    content: msg,
    icon: <img src={warnGreen} />,
  });
};

export const messageLoading = (msg: any) => {
  return message.warning({
    content: msg,
    type: 'loading',
    duration: 0,
  });
};

export const messageWarning = (msg: any, duration?: number) => {
  return message.warning({
    content: msg,
    icon: <img src={warnYellow} />,
    duration,
  });
};

export const messageSuccess = (msg: any) => {
  message.success({
    content: msg,
    icon: <img src={messageSuccessIcon} />,
  });
};

export function messageError(msg: any, key?: string | number) {
  // 用来处理101305参数错误，之前接口的单独报错不额外提示
  if (!isMessageLocked) {
    message.error({
      content: msg,
      key,
      icon: <img src={messageErrorIcon} />,
    });
  }
}
